<div class="main-content">
    <div class="main-heading">
        <strong><span translate>NEW_PROJECT</span></strong>
    </div>
    <div class="card">
        <div class="card-body">
            <project-form (isEdit)="true"></project-form>
        </div>
    </div>
</div>